exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-margin-bottom {\n  margin-bottom: 30px !important;\n}\n#matrix-props .button.is-static {\n  border: none !important;\n}\n.text-center {\n  text-align: center !important;\n}\n", ""]);

// exports
